import { differenceInMinutes } from '@repo/date-time';
import { ParkTimeContractType, type ParkTimeContract, type Reservation } from '@repo/domain';

/**
 * Derives the pricing `ParkTimeContract` from a reservation's committed interval.
 * The reservation stores its window as concrete `startAt`/`endAt` dates, while
 * `usePriceDebounced` expects a contract — so we reconstruct a fixed-duration contract of
 * the booked length (stable, unlike a fixed-end contract which would shrink as
 * "now" advances).
 */
export const getReservationParkTimeContract = (reservation: Reservation): ParkTimeContract => ({
  type: ParkTimeContractType.FixedDuration,
  duration: differenceInMinutes(reservation.endAt, reservation.startAt),
});
